import { GET_ALL_SECTORS_LIST } from "../types";

export const getAllSectorsList = () => ({
	type: GET_ALL_SECTORS_LIST
})




// WEBPACK FOOTER //
// src/redux/actions/allSectorsActions.js